import { render, staticRenderFns } from "./MemberFamilyMembers.vue?vue&type=template&id=8735de12&scoped=true"
import script from "./MemberFamilyMembers.vue?vue&type=script&lang=js"
export * from "./MemberFamilyMembers.vue?vue&type=script&lang=js"
import style0 from "./MemberFamilyMembers.vue?vue&type=style&index=0&id=8735de12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8735de12",
  null
  
)

export default component.exports